<template>
  <main class="mt00">
    <div class="job-detail">
      <h2>
        <span  v-if="job.prefInfo">{{ job.prefInfo.name }} - {{ job.prefInfo.name_r }}</span>
        {{ job.summary }}
      </h2>
      <div class="job-box">
        <dl>
          <dt>{{$t('hourlyWage')}}</dt>
            <dd v-if="job.salaryFrom">
              <span>&yen;{{ job.salaryFrom.toLocaleString() }}</span>
              <span v-if="job.salaryTo"> 〜 &yen;{{ job.salaryTo.toLocaleString() }}</span>
            </dd>
          <dt>{{$t('japaneseLevel')}}</dt>
          <dd v-if="job.japlabel">{{ job.japlabel.level }}</dd>
          <dt>{{$t('workingHours')}}</dt>
          <dd>
            <span>{{ job.hour1F }} 〜 {{ job.hour1T }} {{ job.hour1W }}</span><br>
            <span v-if="job.hour2F">{{ job.hour2F }} 〜 {{ job.hour2T }} {{ job.hour2W }}</span><br>
            <span v-if="job.hour3F">{{ job.hour3F }} 〜 {{ job.hour3T }} {{ job.hour3W }}</span>
          </dd>
          <dt v-if="job.nearSta1 || job.nearSta2 || job.nearSta3">{{$t('closestStation')}}</dt>
          <dd v-if="job.nearSta1 || job.nearSta2 || job.nearSta3">
            <span v-if="job.nearSta1">{{ job.nearSta1 }} {{ job.nearSta1W }}</span><br>
            <span v-if="job.nearSta2">{{ job.nearSta2 }} {{ job.nearSta2W }}</span><br>
            <span v-if="job.nearSta3">{{ job.nearSta3 }} {{ job.nearSta3W }}</span>
          </dd>
          <dt v-if="job.other">{{$t('other')}}</dt>
          <dd style="white-space:pre-line">{{ job.other }}</dd>
        </dl>
      </div>
    </div>
    <firebaseError :error="this.fbError" :errorCode="errorCode"/>
    <p class="btn-normal">
      <router-link to="" @click.native="applyJob">{{$t('applyJob')}}</router-link>
    </p>
  </main>
</template>

<script>
import firebase from 'firebase'
import prefs from '@/constants/PrefsEnum'
import langLevels from '@/constants/langLevelsEnum'
import firebaseError from "@/error/FirebaseError"

export default {
  name: 'Job',
  mixins: [prefs, langLevels],
  data () {
    return {
      db: firebase.firestore(),
      uid: firebase.auth().currentUser.uid,
      job: {},
      fbError: false, //firebaseエラー
      errorCode: "",
    }
  },
  components: {
    firebaseError,
  },
  async created () {
    const jobId = this.$route.params.id
    if (!jobId) {
      this.$router.push({ name: 'NotFound' })
      return
    }
    const doc = await this.db.collection("jobs").doc(jobId).get()
    if (!doc.exists) {
      this.$router.push({ name: 'NotFound' })
      return
    }
    const data = doc.data()
    this.job = {
      id: doc.id,
      summary: data.summary,
      applyUrl: data.apply_url,
      prefInfo: this.prefs.find(e => e.code == data.pref_code),
      salaryFrom: data.salary_from.toLocaleString(),
      salaryTo: this.isNotEmpty(data.salary_to) ? data.salary_to.toLocaleString() : null,
      japlabel: this.langLevels.find(e => e.code == data.japanese_level_code),
      hour1F: data.working_hours1_from,
      hour1T: data.working_hours1_to,
      hour1W: data.working_hours1_word,
      hour2F: data.working_hours2_from,
      hour2T: data.working_hours2_to,
      hour2W: data.working_hours2_word,
      hour3F: data.working_hours3_from,
      hour3T: data.working_hours3_to,
      hour3W: data.working_hours3_word,
      nearSta1: data.nearrest_station1,
      nearSta1W: data.nearrest_station1_word,
      nearSta2: data.nearrest_station2,
      nearSta2W: data.nearrest_station2_word,
      nearSta3: data.nearrest_station3,
      nearSta3W: data.nearrest_station3_word,
      other: data.other.replace(/\n/g,'\n'),
    }
    this.db.collection("job_detail_view_histories").add({
      job_id: this.job.id,
      user_id: this.uid,
      browsed_at: firebase.firestore.FieldValue.serverTimestamp(),
    })
  },
  methods: {
    applyJob () {
      this.db.collection("job_apply_histories").add({
        job_id: this.job.id,
        user_id: this.uid,
        applied_at: firebase.firestore.FieldValue.serverTimestamp(),
      })
      open(this.job.applyUrl, "_blank")
    },
  },
}
</script>
